import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import GasDetailGraph from './gasDetailGraph/GasDetailGraph';
import GasGraphSearchBar from './gasGraphSearchBar/GasGraphSearchBar';

const GasGraph = () => {
  const gasCriterion = useSelector((store) => store.criterion).gas;
  const [searchMap, setSearchMap] = useState({
    moduleIdx: 0,
    beginDate: new Date(),
    endDate: new Date(),
    moduleScn: '0',
  });

  return (
    <section>
      <GasGraphSearchBar searchMap={searchMap} setSearchMap={setSearchMap} />
      <GasDetailGraph searchMap={searchMap} gasCriterion={gasCriterion} />
    </section>
  );
};

export default GasGraph;
